import { render, staticRenderFns } from "./AdministrationDialog.vue?vue&type=template&id=d8d560fa&"
import script from "./AdministrationDialog.vue?vue&type=script&lang=js&"
export * from "./AdministrationDialog.vue?vue&type=script&lang=js&"
import style0 from "./AdministrationDialog.vue?vue&type=style&index=0&id=d8d560fa&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports